import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useClasses from '../../../../../hooks/classes/useClasses'
import Module from '../../../../layout/Module'
import { useNavigate } from 'react-router-dom'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { updateClassForm, updateClassPreview } from '../../../../../store/actions/class.actions'
import { useParams } from 'react-router-dom'
import TextLog from '../../../../text/TextLog'
import TextNote from '../../../../text/TextNote'
import { Checkbox, Chip, Menu } from '@mui/material'
import ListMenu from '../../../../commom/ListMenu'
import { updateColumnTableCurriculum } from '../../../../../store/actions/datatable.actions'
import { getObjectCurriculumElementsDR } from '../../utils'
import useSubjects from '../../../../../hooks/subjects/useSubjects'
import TextNotAssigned from '../../../../text/TextNotAssigned'
import { updateClassDialog } from '../../../../../store/actions/class.actions'
import FilterButtonClasses from '../Filter/Filter'
import TextEllipsis from '../../../../text/TextEllipsis'
import Table from './Table'
import Grid from './Grid'
import CardInfo from './CardInfo'
import MenuButton from '../../../../button/MenuButton'
import { updateFilter } from '../../../../../store/actions/filter.actions'
import useDate from '../../../../../hooks/app/useDate'

const List = ({ view }) => {
  const maxItems = 10
  const navigate = useNavigate()
  const { curriculumId, studentId } = useParams()
  const dispatch = useDispatch()
  const permissions = useSelector((state) => state?.session?.permissions?.class || {})
  const years = useSelector((state) => state?.tenant?.years || [])
  const subjects = useSelector((state) => state?.subject?.list || [])
  const redirectStudentId = studentId ? `${studentId}/` : ''

  const { isLoading: isLoadingSubject } = useSubjects()
  const { isLoading, isLoadingList, getClasses } = useClasses()

  const list = useSelector((state) => (state?.class ? state?.class[curriculumId]?.list || [] : []))
  const totalList = useSelector((state) => (state?.class ? state?.class[curriculumId]?.totalList || 0 : 0))
  const totalIds = useSelector((state) => (state?.class ? state?.class[curriculumId]?.totalIds || [] : []))
  const existLinceseAssessment = useSelector((state) =>
    state?.tenant?.license?.find((license) => license.code === 'assessment')
  )

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const curriculumList = useSelector((state) => state?.assessment?.curriculum)
  const state = useSelector((state) => state?.filter?.class)
  const skip = useSelector((state) => state?.datatable?.class?.skip || 0)
  const rowsPerPage = useSelector((state) => state?.datatable?.class?.rowsPerPage || 50)
  const columnsTable = useSelector((state) => state?.datatable?.class?.[curriculumId] || [])
  const [menuEdit, setMenuEdit] = useState({ mouseX: null, mouseY: null })
  const [dataMenu, setDataMenu] = useState(null)
  const [checkIds, setCheckIds] = useState([])

  const { determinateStatus } = useDate()

  const onSelectedAll = (checked) => {
    if (checked) {
      setCheckIds(totalIds.map((row) => row._id))
    } else {
      setCheckIds([])
    }
  }
  const onSelected = (id, checked) => {
    if (checked) {
      setCheckIds([...checkIds, id])
    } else {
      setCheckIds(checkIds.filter((item) => item !== id))
    }
  }

  useEffect(() => {
    if (!isLoading) {
      setDataMenu(null)
      setCheckIds([])
    }
  }, [list])

  useEffect(() => {
    const classes = list?.filter((item) => checkIds.includes(item._id)) || []
    let curriculumElements = classes[0]?.curriculumElements
    const isSameCurriculumElements = classes.every(
      (item) => JSON.stringify(item.curriculumElements) === JSON.stringify(curriculumElements)
    )

    let data = { _id: checkIds, curriculumId, classes, students: [], teachers: [] }
    if (isSameCurriculumElements) {
      data.curriculumElements = curriculumElements
    }
    if (classes.some((item) => item.unitOfLearnings?.length > 0)) {
      data.unitOfLearnings = classes.map((item) => item.unitOfLearnings).flat()
    }
    if (checkIds.length > maxItems) {
      data.error = `Exceeded the number of classes for batch edit. Please select ${maxItems} or less.`
    }

    setDataMenu(data)
  }, [checkIds])

  const onDialog = (type, form) => {
    dispatch(updateClassDialog(true, type, form))
  }
  useEffect(() => {
    getClasses(curriculumId, skip, rowsPerPage, state?.filter)
  }, [curriculumId, rowsPerPage, skip, state, state?.filter])

  useEffect(() => {
    const showStudents = permissions?.list?.includes('all') || permissions?.list?.includes('by-teacher')
    const columns = [
      { label: 'Code', key: 'code', align: 'left', width: 500, show: true, hide: true, position: 1 },
      { label: 'Name', key: 'name', align: 'left', width: 500, show: false, hide: true, position: 2 },
      {
        label: 'Description',
        key: 'description',
        align: 'center',
        width: 200,
        show: false,
        hide: true,
        position: 3
      },
      {
        label: 'Year level',
        key: 'yearLevel',
        align: 'left',
        width: 250,
        show: true,
        hide: true,
        position: 3
      },
      { label: 'Teachers', key: 'teachers', show: true, width: 120, hide: true, position: 8 },
      {
        label: '# of Students',
        key: 'lenStudents',
        align: 'center',
        className: 'text-center',
        show: showStudents,
        width: 80,
        hide: showStudents,
        position: 9
      },
      {
        label: '# of Units of learning',
        key: 'lenUL',
        align: 'center',
        className: 'text-center',
        show: existLinceseAssessment,
        width: 80,
        hide: true,
        position: 9
      }
    ]
    if (existLinceseAssessment) {
      if (!['unassigned', 'assigned', 'all'].includes(curriculumId) && currentCurriculum) {
        const elements = {}
        if (currentCurriculum.elementsStructure) {
          elements[currentCurriculum.elementsStructure?._id] = {
            label: currentCurriculum.elementsStructure?.name,
            key: 'elementId',
            show: true,
            caret: true,
            hide: true,
            position: 4,
            width: 100,
            className: 'text-nowrap'
          }

          const subElement = currentCurriculum.elementsStructure?.children[0]
          if (subElement) {
            elements[subElement?._id] = {
              label: subElement?.name,
              key: 'subElementId',
              show: true,
              caret: true,
              hide: true,
              position: 5,
              width: 100,
              className: 'text-nowrap'
            }
          }
        }

        Object.keys(elements).forEach((key) => {
          columns.push(elements[key])
        })
      }

      if (['unassigned', 'assigned', 'all'].includes(curriculumId)) {
        columns.push({
          label: 'Curriculum',
          key: 'curriculum',
          align: 'left',
          width: 250,
          show: true,
          hide: true,
          position: 5
        })
      }
    }
    if (subjects?.length > 0) {
      columns.push({
        label: 'Subject',
        key: 'subjectId',
        align: 'left',
        width: 250,
        show: true,
        hide: true,
        position: 6
      })
    }
    columns.sort((a, b) => a.position - b.position)
    dispatch(updateColumnTableCurriculum(curriculumId, 'class', columns))
  }, [subjects, curriculumId.existLinceseAssessment])

  const onRedirect = (id, step) => {
    navigate(`/dashboard/${redirectStudentId}classes/${curriculumId}/edit/${id}/step/${step}`)
    dispatch(updateFilter('class', {}))
  }
  const handleMenuClose = () => setMenuEdit({ mouseX: null, mouseY: null })
  const handleMenuOpen = (event, data) => {
    setMenuEdit({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    })
    setDataMenu(data)
  }

  const listData = list.map((row, index) => {
    const subject = subjects.find((item) => item._id === row.subjectId)
    const currentCurriculum = curriculumList.find((item) => item._id === row.curriculumId)
    const elements = getObjectCurriculumElementsDR(
      currentCurriculum?.elements,
      currentCurriculum?.elementsStructure,
      row?.curriculumElements || {}
    )
    const yearLevel = row.yearLevel?.map(
      (item) => years.find((year) => String(year._id) === String(item))?.name
    )
    let uls = {}
    row.unitOfLearnings?.forEach((ul) => {
      if (ul.startDate && ul.endDate) {
        const status = determinateStatus(ul.startDate, ul.endDate)
        if (!uls[status]) {
          uls[status] = 1
        } else {
          uls[status]++
        }
      }
    })

    return {
      ...row,
      index: index + 1 + rowsPerPage * skip,
      checkIds: (
        <Checkbox
          id={`checkbox-id-user-${row._id}`}
          checked={checkIds.includes(row._id)}
          onChange={(e) => onSelected(row._id, e.target.checked)}
          color='primary'
        />
      ),
      log: <TextLog updatedAt={row.updatedAt} updatedBy={row.updatedBy} />,
      elementId: elements?.element?.valueName || <TextNotAssigned />,
      subElementId: elements?.subElement?.valueName || <TextNotAssigned />,
      lenStudents: row?.students?.length || 0,
      teachers: (
        <div className='flex gap-1 flex-wrap items-center'>
          {row?.teachers?.length > 0 ? (
            row?.teachers?.map((teacher, index) => (
              <Chip
                key={`class-${row._id}-teacher-${teacher._id}-${index}`}
                label={teacher.lastName}
                variant='outlined'
                color='primary'
                size='small'
              />
            ))
          ) : (
            <TextNotAssigned />
          )}
        </div>
      ),
      lenUL: (
        <div className='flex flex-col gap-1'>
          <Chip
            label={`${uls?.active || 0} Active`}
            variant='outlined'
            style={{
              color: 'var(--accent-foreground)',
              backgroundColor: 'var(--accent)',
              maxWidth: '120px'
            }}
            size='small'
            className='font-bold'
          />
          <Chip
            label={`${uls?.inactive || 0} Inactive`}
            style={{
              color: 'var(--muted-foreground)',
              backgroundColor: 'var(--muted)',
              maxWidth: '120px'
            }}
            size='small'
            className='font-bold'
          />
        </div>
      ),
      subjectId: subject?.name || <TextNotAssigned />,
      yearLevel: yearLevel?.join(', ') || '',
      curriculumName: row?.curriculumId ? (
        <div className='max-w-100px'>
          <TextEllipsis className='text-sm'>
            {currentCurriculum?.shortName} - {currentCurriculum?.name}
          </TextEllipsis>
        </div>
      ) : (
        <TextNotAssigned />
      ),
      curriculum: row?.curriculumId ? (
        <div className='max-w-200px'>
          <TextEllipsis className='text-sm'>
            {currentCurriculum?.shortName} - {currentCurriculum?.name}
          </TextEllipsis>
          <div className='flex gap-1 items-center'>
            <span className='text-xs font-bold text-nowrap'>{elements?.element?.keyName}</span>
            <TextEllipsis className='text-xs'>{elements?.element?.valueName}</TextEllipsis>
          </div>
          <div className='flex gap-1 items-center'>
            <span className='text-xs font-bold text-nowrap'>{elements?.subElement?.keyName}</span>
            <TextEllipsis className='text-xs'>{elements?.subElement?.valueName}</TextEllipsis>
          </div>
        </div>
      ) : (
        <TextNotAssigned />
      ),
      description: <TextNote notes={row.description || ''} />,
      actions: (
        <div className='flex items-center gap-1 items-center justify-center'>
          {permissions?.preview && (
            <IconTooltipButton
              id={`preview-${row._id}`}
              disabled={isLoading}
              title='Preview'
              icon='expand-alt'
              onClick={() => {
                dispatch(updateClassPreview(row._id))
              }}
            />
          )}
          {existLinceseAssessment && permissions?.updated && (
            <IconTooltipButton
              id={`edit-${row._id}`}
              disabled={isLoading}
              title='Edit'
              icon='pen'
              onClick={(e) => handleMenuOpen(e, row)}
            />
          )}
          {existLinceseAssessment && permissions.archived && (
            <IconTooltipButton
              id={`archive-${row._id}`}
              disabled={isLoading}
              title='Archive'
              icon='archive'
              onClick={() => onDialog('archive', row)}
            />
          )}
          {existLinceseAssessment && permissions.deleted && (
            <IconTooltipButton
              id={`delete-${row._id}`}
              disabled={isLoading}
              title='Delete'
              icon='trash-alt'
              onClick={() => onDialog('delete', row)}
            />
          )}
        </div>
      )
    }
  })

  return (
    <>
      <Module.BodyHeader className='border-b border-b-2 border-primary justify-between'>
        <CardInfo isLoading={isLoadingList || isLoadingSubject} />
        <div className=' w-full'>
          <FilterButtonClasses />
        </div>
        <div className='flex gap-2'>
          {checkIds?.length > 1 && permissions['batch-updated'] && (
            <MenuButton
              title='Batch edit'
              icon='pen'
              disabled={isLoadingList || isLoadingSubject}
              className='text-nowrap'
              items={[
                {
                  label: 'Edit year level',
                  permissions: permissions?.['batch-updated']?.includes('year-level'),
                  onClick: () => onDialog('batch-year-level', dataMenu)
                },
                // {
                //   label: 'Edit curriculum elements',
                //   permissions:
                //     existLinceseAssessment && permissions?.['batch-updated']?.includes('curriculum-elements'),
                //   onClick: () => onDialog('batch-curriculum-elements', dataMenu)
                // },
                {
                  label: 'Edit subject',
                  permissions: existLinceseAssessment && permissions?.['batch-updated']?.includes('subject'),
                  onClick: () => onDialog('batch-subject', dataMenu)
                },
                {
                  label: 'Add students',
                  permissions: permissions?.['batch-updated']?.includes('add-student'),
                  onClick: () => {
                    if (checkIds.length > maxItems) {
                      onDialog('Add students batch', dataMenu)
                    } else {
                      onRedirect('batch', 'add-students')
                      dispatch(updateClassForm(dataMenu))
                    }
                  }
                },
                {
                  label: 'Add teachers',
                  permissions: permissions?.['batch-updated']?.includes('add-teacher'),
                  onClick: () => {
                    if (checkIds.length > maxItems) {
                      onDialog('Add teachers batch', dataMenu)
                    } else {
                      onRedirect('batch', 'add-teachers')
                      dispatch(updateClassForm(dataMenu))
                    }
                  }
                }
              ]}
            />
          )}
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        {view === 'table' && (
          <Table
            curriculumId={curriculumId}
            list={listData}
            loading={isLoadingList || isLoadingSubject}
            totalList={totalList}
            skip={skip}
            rowsPerPage={rowsPerPage}
            columns={[
              { label: '#', key: 'index', align: 'center', width: 10, show: true, hide: false },
              {
                show: permissions['batch-updated'],
                key: 'checkIds',
                align: 'center',
                hide: false,
                width: 15,
                label: (
                  <Checkbox
                    id={`checkbox-id-user-header`}
                    checked={checkIds.length > 0 && checkIds.length === totalIds.length}
                    indeterminate={checkIds.length > 0 && checkIds.length < totalIds.length}
                    onChange={(e) => onSelectedAll(e.target.checked)}
                    color='primary'
                  />
                )
              },
              ...columnsTable,
              {
                label: 'Log',
                key: 'log',
                align: 'center',
                className: 'text-center',
                width: 120,
                show: true,
                hide: false
              },
              { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
            ]}
          />
        )}
        {view === 'grid' && (
          <Grid
            list={listData}
            loading={isLoadingList || isLoadingSubject}
            totalList={totalList}
            skip={skip}
            rowsPerPage={rowsPerPage}
            columns={columnsTable}
          />
        )}
      </Module.BodyContainer>
      {menuEdit && (
        <Menu
          id={`menuEdit-${curriculumId}`}
          MenuListProps={{
            style: { width: '260px' },
            className: 'list-menuEdit p-0'
          }}
          keepMounted
          open={menuEdit.mouseY !== null}
          onClose={handleMenuClose}
          anchorReference='anchorPosition'
          anchorPosition={
            menuEdit.mouseY !== null && menuEdit.mouseX !== null
              ? { top: menuEdit.mouseY, left: menuEdit.mouseX }
              : undefined
          }
        >
          <ListMenu
            id={`menuEdit-list-${curriculumId}`}
            items={[
              {
                label: 'Edit basic information',
                permissions:
                  permissions?.updated?.includes('basic-information') ||
                  permissions?.updated?.includes('year-level'),
                onClick: () => onDialog('basic-information', dataMenu)
              },
              // {
              //   label: 'Edit curriculum elements',
              //   permissions: existLinceseAssessment && permissions?.updated?.includes('curriculum-elements'),
              //   onClick: () => onDialog('curriculum-elements', dataMenu)
              // },
              {
                label: 'Edit subject',
                permissions: existLinceseAssessment && permissions?.updated?.includes('subject'),
                onClick: () => onDialog('subject', dataMenu)
              },
              {
                label: 'Add students',
                permissions: permissions?.updated?.includes('add-student'),
                onClick: () => onRedirect(dataMenu._id, 'add-students')
              },
              {
                label: 'Add teachers',
                permissions: permissions?.updated?.includes('add-teacher'),
                onClick: () => onRedirect(dataMenu._id, 'add-teachers')
              },
              {
                label: 'Remove students',
                permissions: permissions?.updated?.includes('remove-student'),
                onClick: () => onRedirect(dataMenu._id, 'remove-students')
              },
              {
                label: 'Remove teachers',
                permissions: permissions?.updated?.includes('remove-teacher'),
                onClick: () => onRedirect(dataMenu._id, 'remove-teachers')
              }
            ]
              .filter((item) => item.permissions)
              .map((item) => ({
                ...item,
                onClick: () => {
                  if (item.onClick) {
                    item.onClick()
                  }
                  handleMenuClose()
                }
              }))}
          />
        </Menu>
      )}
    </>
  )
}

export default List
